import IconeFace from "../../img/Circle Button over.svg";
import IconeX from "../../img/Circle Button over-1.svg";
import IconeLinkedIn from "../../img/Circle Button over-2.svg";
import IconeYoutube from "../../img/Circle Button over-3.svg";


function Rodape() {
  return (
    <footer className="rodape">
      <div className="container rodape-container">
        {/* Ícones de redes sociais */}
        <div className="rodape-redes">
          <a href="#" aria-label="Facebook" className="rodape-icone">
            <img src={IconeFace} alt=" Icone Facebook" />
          </a>

          <a href="#" aria-label="Twitter / X" className="rodape-icone">
            <img src={IconeX} alt="Icone X" />
          </a>

          <a href="#" aria-label="LinkedIn" className="rodape-icone">
            <img src={IconeLinkedIn} alt="Icone LinkedIn" />
          </a>

          <a href="#" aria-label="YouTube" className="rodape-icone">
            <img src={IconeYoutube} alt="Icone Youtube" />
          </a>
        </div>

        {/* E-mail de contato */}
        <div className="rodape-contato">
          Example@fieb.org.br
        </div>

        {/* Direitos autorais */}
        <div className="rodape-copy">
          Copyright © 2025 SENAI. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Rodape;
